import T from 'prop-types';
import React from 'react';
import {
  clearUserInLocalStorage,
  restoreUserImpersonatorInLocalStorage,
} from 'services/authentication/helpers/local-storage';
import * as Auth0 from 'shared/helpers/auth0';

export default class LogoutPage extends React.Component {
  static propTypes = {
    doLogout: T.func.isRequired,
  };

  componentDidMount() {
    restoreUserImpersonatorInLocalStorage();
    clearUserInLocalStorage();
    Auth0.logout();
  }

  render() {
    return null;
  }
}
